import { labelLarge, labelMedium, labelSmall } from '@aon/aon-tws-common-ui/build/lib/globalCss';
import styled from 'styled-components';

export interface ILabelProps {
	marginBottom?: string;
	size: 'sm' | 'md' | 'lg';
}

export const Label = styled.div.attrs<ILabelProps, any>((props: ILabelProps) => ({
	className: props.size,
}))`
	${(props) => props.size === 'sm' && labelSmall};
	${(props) => props.size === 'md' && labelMedium};
	${(props) => props.size === 'lg' && labelLarge};
	margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '10px')};
`;
Label.displayName = 'Label';
